import React from 'react';

const QRTypeSelector = ({ qrType, onTypeChange }) => {
  const qrTypes = [
    { value: 'url', label: '🌐 URL', description: 'Links para websites' },
    { value: 'text', label: '📝 Texto', description: 'Texto simples' },
    { value: 'vcard', label: '👤 vCard', description: 'Informações de contato' },
    { value: 'wifi', label: '📶 WiFi', description: 'Credenciais de rede WiFi' }
  ];

  return (
    <div className="form-group">
      <label htmlFor="qrType">Tipo de QR Code</label>
      <select
        id="qrType"
        value={qrType}
        onChange={(e) => onTypeChange(e.target.value)}
        className="select-input"
      >
        {qrTypes.map(type => (
          <option key={type.value} value={type.value}>
            {type.label} - {type.description}
          </option>
        ))}
      </select>
    </div>
  );
};

export default QRTypeSelector;
